module.exports = __webpack_public_path__ + "static/media/feed.6287330e.png";